import * as actionTypes from '../actions/actionTypes';

const parseJWT = (token) => {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(window.atob(base64));
}

let initialState = {
    info: {
        isAffiliate: false
    },
    me: {}
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_USER_INFO:
            const tokenInfo = parseJWT(action.token);
            //console.log("TOKEN INFO", tokenInfo);
            return {
                ...state,
                info: {
                    ...state.info,
                    token: action.token,
                    ...tokenInfo,
                    name: decodeURIComponent(escape(tokenInfo.name)),
                    isAngel: tokenInfo.angelCanReadStorageIds
                        && ( tokenInfo.angelCanReadStorageIds.length || tokenInfo?.roles?.admin),
                    angelStoragesCount : tokenInfo.angelCanReadStorageIds && tokenInfo.angelCanReadStorageIds.length

                }
            };
        case actionTypes.SET_AFFILIATE_INFO:
            return {
                ...state,
                me: action.me
            };
        case actionTypes.REMOVE_USER_INFO:
            return initialState;

        default:
            return state;
    }
};

export default reducer;